// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vc0Q","right":"Footer_right__3jQiu","buttons":"Footer_buttons__1vnWK"};